
<template>
  <div class="evidence_upload">

    <section
              class="w-2/3 mx-auto text-center mt-10"
              v-if="this.isSaving || this.isSuccess"
            >

              <div class="progress-circle__container">
                <span class="progress-circle__percent font-bold text-lg"
                  >{{ completedPercentage }}%</span
                >

                <svg
                  class="progress-circle"
                  viewBox="0 0 106 106"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                  <g
                    id="Page-1"
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <g
                      id="ProgressBar"
                      transform="translate(-17.000000, -17.000000)"
                    >
                      <circle
                        id="Oval"
                        stroke="#949494"
                        stroke-width="7"
                        fill-rule="nonzero"
                        cx="70"
                        cy="70"
                        r="50"
                      ></circle>
                      <path
                        class="progress-circle__path"
                        d="M70,120 C97.6142375,120 120,97.6142375 120,70 C120,42.3857625 97.6142375,20 70,20 C42.3857625,20 20,42.3857625 20,70 C20,97.6142375 42.3857625,120 70,120 Z"
                        id="Oval-Copy"
                        stroke="#1F254A"
                        stroke-width="5"
                        :stroke-dasharray="circle"
                        fill-rule="nonzero"
                        transform="translate(70.000000, 70.000000) rotate(-125.000000) translate(-70.000000, -70.000000) "
                      ></path>
                    </g>
                  </g>
                </svg>
              </div>
              <p>Uploading file</p>
            </section>

            <section v-if="this.isComplete" class="w-full text-center  mt-2">
              <i class="fas fa-check-circle text-green-300 text-2xl"></i
              >
              <h3 class="font-bold text-base text-action-blue">Your file has been stored. </h3>
              <p class="text-action-blue text-xs">
                To save your evidence please complete the fields and click upload evidence below.
                <br/>
                {{ file.name }}
              </p>
              <button
                @click="refreshUpload()"
                type="button"
                class="hover:bg-blue-300 mt-4 underline"
              >
                Choose a different document
              </button>
            </section>



    <div class="infox">
      <a class="button-text right text-red-700" v-if="this.isSuccess" v-on:click="clear()">
          <i class="icon fas fa-trash-alt"/> Replace file
      </a>
  </div>


      <!--UPLOAD-->

       <form enctype="multipart/form-data" novalidate v-if="this.isInitial" v-on:click="showUpload()">

        <div class="flex items-center justify-center w-ful mx-auto">
                  <label
                    class="
                      flex flex-col
                      rounded-lg
                      border-2 border-dashed
                      w-full
                      h-32
                      p-10
                      group
                      text-center
                      cursor-pointer
                    "
                  >
                    <div
                      class="
                        h-full
                        w-full
                        text-center
                        flex flex-col
                        items-center
                        justify-center
                        items-center
                      "
                    >
                      <div class="flex flex-auto max-h-32 w-full mx-auto justify-center content-center text-center">
                       
                       <div>
                        <img
                          class="has-mask h-24 object-center p-2"
                          src="/static/images/empty/document.png"
                          alt="Add document resource"
                        />

                       </div> 
                        <div class="pointer-none text-gray-500 pt-10 pl-2 font-semibold">
                        <span class="text-sm">Click to select</span> a file from
                        your computer
                        </div>
                      </div>
                      
                    </div>
                  </label>
                </div>

       </form>

      <div class="feedback h-20" v-if="this.isSuccess || this.isFailed">

     <!--SUCCESS-->
      <div v-if="isSuccess" class="success">
        <span class="uploaded-msg"> <i class="icon fa-check"/> 1 file has been uploaded</span>
        <i  v-show="loading" class="spinner fa fa-spinner fa-spin"></i>

        <iframe v-if="extension != 'docx'" v-bind:src="pathUrl" width="100%" height="310px" overflow='hidden' class="overflow-hidden"  />
        <div class="word-doc" v-if="extension == 'docx'">
          <h3>Can not display a Word document preview. Please use PDF files to enable content previews.</h3>
          <i class="icon fa fa-file-word-o" aria-hidden="true"></i>

        </div>
      </div>
      <!--FAILED-->
      <section v-if="this.isFailed" class="w-full text-center  mt-2 ">
              <h3 class="font-bold text-base text-red-500">Upload failed </h3>
              <p class="text-action-blue text-xs">
                There was an issue with the upload please try again or use a different file.
                <br/>
                <pre>{{ uploadError }}</pre>
              </p>
              <button
                @click="refreshUpload()"
                type="button"
                class="hover:bg-blue-300 mt-4 underline"
              >
                Choose a different document
              </button>
            </section>


    </div>

  </div>
</template>

<script> 
import { mapGetters } from "vuex";
import { fileEvidenceMixin } from "@/mixins/file-EvidenceMixin.js";

export default {
  name: "evidence_upload",
  props: ["currentFile"],
  mixins: [fileEvidenceMixin],
  data() {
    return {
      uploadedFiles: [],
      uploadError: null,
      uploadFieldName: "photos",
      loading: false,
      pathUrl: null,
      extension: null,
      file: {},
    };
  },
  computed: {
    ...mapGetters({ currentUser: "currentUser" }),

    hasFile() {
      return this.file.name != undefined && this.file.name.length > 3;
    },
    circle() {
      return ((this.completedPercentage / 100) * 100 * Math.PI) + ',9999';
    },
    displayFileName() {
      let str = this.currentFile;
      return str.substring(str.lastIndexOf("/") + 1);
    }
  },
  created() {
    if (this.currentFile.length > 0) {
      this.preload();
    }
  },
  methods: {
    preload() {
      this.setSuccessStatus();
      this.loading = true;
      this.loadDocument(this.currentFile);
    },
    reset() {
      // reset form to initial state
      this.setInitialStatus();
      this.uploadedFiles = [];
      this.uploadError = null;
    },
    clear() {
      this.reset();
      this.$emit("file", "");
    },
    loadDocument(path) {
      var ext = path.split(".").pop();
      this.extension = ext;

      this.getStaticFile(path)
        .then(f => {
          this.loading = false;
          this.pathUrl = f;
          this.setSuccessStatus();
        })
        .catch(err => {
          console.log(err);
         this.setFailedStatus()
        });
    },
    handleFileUpload(formData) {
      // upload data to the server
      var itemId = this.currentUser.schoolID;

      const result = this.uploadEvidence(formData, itemId)

      result.then((response) => {
        console.log("UPPLOADED", this.fileName , this.fileType)
        this.$emit('fileuploaded', {"file": this.fileName, "type": this.fileType});

          // load document
         // this.loadDocument(x.path);
        });
    },
  showUpload() {
      var input = document.createElement('input');
      input.type = 'file';
      input.onchange = e => { 
        this.file = e.target.files[0]; 
        console.log(this.file)
        let formData = new FormData();
        formData.append("file", this.file);
        this.handleFileUpload(formData);
      }
      input.click();
 
    }
  },
  mounted() {
    this.reset();
  }
};
</script>

<style scoped>

.container .input-file {
  opacity: 0;
  width: 41%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.success {
  text-align: center;
  overflow-x: hidden !important;
}

.success iframe {
  padding: 0px;
  marging: 0px;
}

.uploaded-msg {
  font-weight: 700;
  color: #7fc6a4;
}
</style>
